import UserTable from 'components/management/tables/UserTable';
import React, { useEffect } from 'react';
import { UserInfoDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';
import AdminUserFilter from 'components/management/filters/AdminUserFilter';
import styled from 'styled-components';
import { getUrlParam } from 'libs/helper/utils';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import AdminUserForm from 'components/management/modals/AdminUserForm';
import { AdminUserFilterType } from 'types/CommonTypes';

interface AdminUserStatusProps {
  status: 'ACTIVE' | 'INACTIVE';
}

const AdminUserPage = observer(() => {
  const { uiStore, userFilterStore } = useStoreWrapper();
  const location = useLocation();

  const onFilterChange = (filter: AdminUserFilterType) => {
    userFilterStore.setAdminUserFilter(filter);
  };

  const fetchAdminUsers = () => {
    const searchKeyword = getUrlParam('searchKeyword');
    const page = getUrlParam('page');
    const size = getUrlParam('size');

    userFilterStore.getAdminUsers({
      searchKeyword: searchKeyword || '',
      page: page ? parseInt(page) - 1 : 0,
      size: size ? parseInt(size) : 20,
    });
  };

  // 관리자 계정 추가
  const handleClickModify = (adminUser?: UserInfoDto) => {
    uiStore?.modal.show({
      title: (
        <div>
          {adminUser?.id ? '관리자 정보 수정' : '관리자 계정 추가'}
          {adminUser?.id && (
            <Status status={adminUser?.isWithdrawn ? 'INACTIVE' : 'ACTIVE'}>
              {getStatusText(adminUser?.isWithdrawn ? 'INACTIVE' : 'ACTIVE')}
            </Status>
          )}
        </div>
      ),
      style: {
        width: '100%',
        maxWidth: '800px',
        height: '100%',
        maxHeight: '80vh',
      },
      children: <AdminUserForm adminUser={adminUser} onSave={fetchAdminUsers} />,
    });
  };

  const getStatusText = (status: AdminUserStatusProps['status']) => {
    switch (status) {
      case 'ACTIVE':
        return '활성화';
      case 'INACTIVE':
        return '비활성화';
      default:
        return '';
    }
  };

  useEffect(() => {
    fetchAdminUsers();
  }, [location.search]);

  return (
    <div>
      <AdminUserFilter
        onclick={onFilterChange}
        onClickAdd={() => {
          handleClickModify();
        }}
      />
      <UserTable
        users={userFilterStore.filteredAdminUsers}
        onEditBtnClick={(user: UserInfoDto) => handleClickModify(user)}
      />
    </div>
  );
});

const EmptyText = styled.div`
  text-align: center;
  margin-top: 20px;
`;

const Status = styled.span<AdminUserStatusProps>`
  display: inline-flex;
  align-items: center;
  padding: 4px 20px;
  border-radius: 12px;
  font-size: 13px;
  justify-content: flex-start;
  font-weight: 500;
  background-color: ${(props) => {
    if (props.status === 'ACTIVE') return 'rgb(230, 247, 255)';
    if (props.status === 'INACTIVE') return 'rgb(255, 241, 240)';
    return '#f5f5f5';
  }};
  color: ${(props) => {
    if (props.status === 'ACTIVE') return '#0067a7';
    if (props.status === 'INACTIVE') return 'rgb(255, 77, 79)';
    return '#666';
  }};
`;

export default AdminUserPage;
